
import { defineComponent } from 'vue'
import {ComponentEnum} from '@/config/config-types';

import {FungusRecordField, newSpecimen} from "@/config/config-fungus"
import CategoryPicker from "@/components/picker/CategoryPicker.vue"
import StringPicker from "@/components/picker/StringPicker.vue"
import Button from "primevue/button";
import InfoButton from "@/components/legend/InfoButton.vue";

export default defineComponent({
  name: "SpecimenPickerItem",
  components: {StringPicker, CategoryPicker, Button, InfoButton},
  data() {
    return {
      ComponentEnum,
      specimen: newSpecimen() as FungusRecordField[]
    }
  },
  props: {
    value: {type: [] as any[], required: true},
    idx: {type: Number, required: true}
  },
  methods: {
    select(value: any) {
      this.$emit('select', {value: value.value, key: value.key, idx: this.idx})
    }
  },
  beforeMount() {

    // @ts-ignore
    this.specimen[0].value = this.value["specimenType"]
    // @ts-ignore
    this.specimen[1].value = this.value["herbarium"]
    // @ts-ignore
    this.specimen[2].value = this.value["specimenLabel"]

  }
})
